<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle title="Saúde Criança" description="" url="/dashboard" />
        </div>
      </div>
      <div class="row">
        <div class="grid-itens">
          <div v-for="(item, index) in cards" :key="index" class="item-flex">
            <router-link :to="item.link">
              <div class="item">
                <i v-if="item.icone !== false" :class="item.icone"></i>
                <img v-else :src="item.imagem" alt="" />
                <h3>
                  {{ item.titulo }}
                </h3>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'

export default {
  name: 'SaudeCrianca',
  components: {
    Menu,
    Footer,
    SectionTitle
  },
  computed: {
    cards() {
      return this.$store.state?.permissoes?.saude_crianca
    }
  },
  data() {
    return {}
  }
}
</script>

<style></style>
